import type { FloorId } from '@/data/floors';
import { byggEtasjeNummer } from '@/data/building';

/**
 * Sentral datafil for tid-som-valuta (fase 1, Mad TV-mekanikk).
 * ALLE tidskostnader i spillet defineres her — aldri hardkodet i scener.
 * Klokka måles i minutter siden midnatt.
 */

/** Spilldagen starter 08:00. */
export const DAG_START_MINUTT = 8 * 60;

/** Spilldagen slutter 17:00 — da trigges dagsoppsummeringen. */
export const DAG_SLUTT_MINUTT = 17 * 60;

/** Diskret varsel i HUD når det er under én time igjen av dagen. */
export const VARSEL_GRENSE_MINUTT = 60;

/**
 * Etasjenummer for heisavstand — avledet fra bygningsdataene i
 * data/building.ts (fase 2), så heis, korridorer og tidskostnad alltid
 * er enige om hvor rommene ligger.
 */
export const ETASJE_NUMMER: Record<FloorId, number> = byggEtasjeNummer();

export type TidsHandling =
  | 'heisPerEtasje'
  | 'romskifteSammeEtasje'
  | 'samtaleKort'
  | 'samtaleLang'
  | 'lesManus'
  | 'manusVurdering'
  | 'redigeringStart'
  | 'coverRunde'
  | 'kampanjeKjop'
  | 'forfatterMote'
  | 'skriving';

/** Tidskostnad i minutter per handlingstype. */
export const TIDSKOSTNADER: Record<TidsHandling, number> = {
  heisPerEtasje: 5,
  romskifteSammeEtasje: 2,
  samtaleKort: 15,
  samtaleLang: 30,
  lesManus: 60,
  // Kjernehandlinger — gjør at en spilldag faktisk er for kort til alt.
  manusVurdering: 30,
  redigeringStart: 30,
  coverRunde: 30,
  kampanjeKjop: 20,
  forfatterMote: 30,
  skriving: 60,
};

/**
 * Minutter det koster å flytte seg fra ett rom til et annet.
 * Samme rom: gratis. Samme etasje: 2 min. Ellers 5 min per etasje
 * med heisen.
 */
export function romskifteKostnad(fra: FloorId, til: FloorId): number {
  if (fra === til) return 0;
  const avstand = Math.abs(ETASJE_NUMMER[til] - ETASJE_NUMMER[fra]);
  if (avstand === 0) return TIDSKOSTNADER.romskifteSammeEtasje;
  return avstand * TIDSKOSTNADER.heisPerEtasje;
}
